import { ContactPage } from 'features/public-contact/ContactPage';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { config } from 'utils/config';

export default ContactPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'contact'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
